// extracted by mini-css-extract-plugin
export default {"map":"FvTq9H0ZJ6","click":"WiA7y2-C-s","container":"kHmyaUX3hM","widget":"_2TtrLBPpOu"};